import axios from "axios"
import FingerprintService from './FingerprintService'
export default function () {
    const apiUrl = process.env.VUE_APP_API_URL;
    const fingerprint = new FingerprintService();

    let store = null;

    //key of the field used to store the account token in localstorage
    //In case if for some reason the backend is redone and existing tokens are invalidated on the backend -
    //a quick fix is to just change this field so returning users would fetch a new token - although we'd lose all
    //their prev data that way. So probably never do that. K.
    const ACCOUNT_TOKEN_FIELD = "token";


    //Fetch token as soon as this is created - either from localStorage or api. Later, this function will
    //always be called to retrieve the token

    this.setStore = newStore => {
        store = newStore;
    };

    this.tokenPromise = getFingerprintAndFistBump();

    this.reset = function() {
        localStorage.clear();
        this.tokenPromise = getFingerprintAndFistBump();
        //document.location.reload();
    };


    /**
     * Returns the full URL to a given endpoint, without a trailing slash
     */
    function url(endpoint)
    {
        const url = apiUrl + "/" + endpoint;
        window.console.log("Endpoint: ", url);
        return url ;
    }

    /**
     * Handles the error response returned by an endpoint
     */
    function onError(error) {
        window.console.error(error);
        store.commit("setError", "Sorry, we couldn't reach our servers. Please refresh this page, or contact us at" +
                    " hi@naminus.com if this issue persists.")
    }

    function getFingerprintAndFistBump() {
        return fingerprint.hashPromise
                    .then(hash => fistbump(hash))
    }

    function fistbump(hash) {
        window.console.log("Fetching token", hash);
        const existingToken = localStorage.getItem(ACCOUNT_TOKEN_FIELD);
        if (existingToken != null) {

            window.console.log("Got token from localStorage:", existingToken);
            return Promise.resolve(existingToken);
        }


        const ua = (navigator && navigator.userAgent && navigator.userAgent.trim)
                    ? navigator.userAgent.trim()
                    : "(Unknown)";


        const path = (document && document.location) ? document.location.hash : "?";
        const data = {fist: hash, userAgent: ua, ip: "", ref: document.referrer, path: path};
        window.console.log("Making fistbump request, data: ", data);

        const promise = axios
                    .post( url("fistbump"), data )
                    .then(result => {
                        window.console.log("Got fistbump response: ", result.data);
                        localStorage.setItem(ACCOUNT_TOKEN_FIELD, result.data.token);

                        //This will have the promise resolve to the token instead of the response:
                        return result.data.token;
                    });

        promise.catch(onError);

        return promise;
    }

    function authHeaders(token) {

        //From https://stackoverflow.com/a/42879201/49153 - returns axios config w/ an auth header
        //Used to send auth headers in axios requests
        return {
            headers: {'Authorization': "bearer " + token}
        }
    }
}
